import template from "./quote-edit.html";

const QuoteEditComponent = {
  bindings: {
    quote: "<",
    quoteLanguageResource: "<",
    updatedRatesLastDate: "<",
    existCostWithDifferentCurrency: "&",
    areRatesUpdated: "&",
    updateRates: "&",
    savingEdition: "=",
  },
  template: template,
  controller: class QuoteEditController {
    /* @ngInject */
    constructor($rootScope) {
      this.$rootScope = $rootScope;
    }

    $onInit() {
      this.$rootScope.quoteEditing = this.quote;
    }

    async addQuoteSection(index, type, quoteSection) {
      this.quote.lastVersion.addSection(index, type, quoteSection);
      if (
        quoteSection &&
        quoteSection.currency &&
        quoteSection.currency !== this.quote.lastVersion.currency
      ) {
        this.quote.lastVersion.updateCurrency(
          quoteSection.currency,
          this.quote.lastVersion.currency
        );
      }
      await this.quote.updateSections();
    }

    async updateQuoteSection(index, section) {
      this.savingEdition = true;
      this.$rootScope.$applyAsync();
      this.quote.lastVersion.sections[index] = section;
      await this.quote.updateSections();
      this.savingEdition = false;
      this.$rootScope.$applyAsync();
    }

    async moveUpSection(index) {
      this._animateMoveUp(index);
      this.quote.lastVersion.moveUpSection(index);
      await this.quote.updateSections();
      if ($(`.quote-section-${index}-video`)[0])
        $(`.quote-section-${index}-video`)[0].load();
      if ($(`.quote-section-${index - 1}-video`)[0])
        $(`.quote-section-${index - 1}-video`)[0].load();
    }

    async moveDownSection(index) {
      this._animateMoveDown(index);
      this.quote.lastVersion.moveDownSection(index);
      await this.quote.updateSections();
      if ($(`.quote-section-${index}-video`)[0])
        $(`.quote-section-${index}-video`)[0].load();
      if ($(`.quote-section-${index + 1}-video`)[0])
        $(`.quote-section-${index + 1}-video`)[0].load();
    }

    async deleteQuoteSection(index) {
      this.quote.lastVersion.deleteSection(index);
      await this.quote.updateSections();
    }

    async applyCustomStyleToQuote(style) {
      this.quote.lastVersion.applyCustomStyleToQuote(style);
      await this.quote.updateSections();
    }

    _animateMoveUp(index) {
      const previousSectionDOM = $(`.quote-section-${index - 1}`);
      $("body, html").animate(
        { scrollTop: previousSectionDOM.offset().top - 70 },
        1000
      );
    }

    _animateMoveDown(index) {
      const sectionDOM = $(`.quote-section-${index}`);
      const nextSectionHeight = $(`.quote-section-${index + 1}`)[0]
        .offsetHeight;
      $("body, html").animate(
        { scrollTop: sectionDOM.offset().top + nextSectionHeight - 70 },
        1000
      );
    }
  },
};

export default QuoteEditComponent;
